// File: lokasiService.js

import axios from 'axios';
import Cookies from 'js-cookie';

const BASE_URL_BE = process.env.REACT_APP_BASE_URL_BE;

const getAuthToken = () => Cookies.get('access_token');

const getAuthHeaders = () => ({
  'Authorization': `Bearer ${getAuthToken()}`, 
  'Content-Type': 'application/json'
});

const LOKASI_ENDPOINT = "/lokasi"; 

// --- FETCH DATA LOKASI ---
export const fetchLokasis = async (params = {}) => { 
  try {
    const urlParams = new URLSearchParams({});
    
    if (params.disable_pagination) {
        urlParams.append('disable_pagination', 'true');
    } else {
        urlParams.append('page', params.page || 1);
        urlParams.append('per_page', params.per_page || 10);
    }
    
    if (params.nama_lokasi) { 
      urlParams.append('nama_lokasi', params.nama_lokasi); 
    }
    
    const response = await axios.get(`${BASE_URL_BE}${LOKASI_ENDPOINT}?${urlParams.toString()}`, {
      headers: getAuthHeaders()
    });
    
    return response.data;
  } catch (error) {
    console.error("Error fetching Lokasis:", error);
    throw error;
  }
};

// --- CREATE LOKASI ---
export const createLokasi = async (formData) => {
  try {
    const response = await axios.post(`${BASE_URL_BE}${LOKASI_ENDPOINT}`, formData, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error creating Lokasi:", error);
    throw error;
  }
};

// --- UPDATE LOKASI ---
export const updateLokasi = async (id_lokasi, formData) => {
  try {
    const response = await axios.put(`${BASE_URL_BE}${LOKASI_ENDPOINT}/${id_lokasi}`, formData, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error updating Lokasi:", error);
    throw error;
  }
};

// --- DELETE LOKASI ---
export const deleteLokasi = async (id) => {
  try {
    const response = await axios.delete(`${BASE_URL_BE}${LOKASI_ENDPOINT}/${id}`, {
      headers: getAuthHeaders()
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting Lokasi:", error);
    throw error;
  }
};

// --- UPLOAD SVG SITEPLAN ---
export const uploadSvgLokasi = async (formData) => {
  try {
    const response = await axios.post(
      `${BASE_URL_BE}${LOKASI_ENDPOINT}/upload-svg`,
      formData,
      {
        headers: {
          'Authorization': `Bearer ${getAuthToken()}`,
          // Jangan set Content-Type manual, biarkan browser yang set (multipart/form-data)
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error upload SVG Lokasi:", error);
    throw error;
  }
};